import PromineoCountDownTimer from "components/common/PromineoCountDownTimer";

interface Props {
  expireAt: string;
}

export default function VerificationCodeCountDownTimer(props: Props) {
  const { expireAt } = props;

  // key used by react to identify changes.(Suggested by Countdown package doc.)
  // Without this prop, component will not rerender on expireAt prop change.
  return (
    <PromineoCountDownTimer
      date={expireAt}
      key={expireAt}
      renderer={(props) => (
        <>
          <div className="font-bold text-sm">Verification code valid for:</div>
          <div className="text-2xl font-bold">
            <div className="inline-block w-18">
              {props.formatted.minutes}:{props.formatted.seconds}
            </div>
            <div className="inline-block ml-1">mins</div>
          </div>
        </>
      )}
    />
  );
}
